import { Account, TableType } from './types';

const ACCOUNT_REGEXP: Record<TableType, Array<{ account: Account, regexp: RegExp }>> = {
  '收入': [],
  '其他收入': [
    {
      account: '其他固定收入',
      regexp: new RegExp('.*(自動自転車|自動販売機|駐車場).*'),
    },
    {
      account: '水電通訊費',
      regexp: new RegExp('.*(有線電視|電気|水道料|インターネット|プロバイダー).*'),
    },
    {
      account: '物件一次性收入',
      regexp: new RegExp('.*(更新|礼金).*'),
    },
  ],
  '支出': [
    {
      account: '源泉稅',
      regexp: new RegExp('.*源泉.*'),
    },
    {
      account: '管理費與修繕積立金',
      regexp: new RegExp('.*(管理委託|PM|BM).*'),
    },
    {
      account: '水電通訊費',
      regexp: new RegExp('.*(有線電視|電気|水道料|インターネット|プロバイダー).*'),
    },
    {
      account: '物件手續費',
      regexp: new RegExp('.*(振込|送金).*'),
    },
    {
      account: '設備營繕費用',
      regexp: new RegExp('.*(修理|点検|工事).*'),
    },
    {
      account: '其他一次性運營費用',
      regexp: new RegExp('.*(契約報酬|広告宣伝費|更新報酬|仲介手数料).*'),
    },
    {
      account: '固都稅',
      regexp: new RegExp('.*固定資産税.*'),
    },
  ],
};

export function classifyAccount(
  tableType: TableType,
  description: string,
): Account | null {
  for (const { account, regexp } of ACCOUNT_REGEXP[tableType]) {
    if (description.match(regexp)) {
      return account;
    }
  }
  return null;
}
